import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[Disablepaste]'
})
export class DisablepasteDirective {

  constructor() { }
    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }
}

@Directive({
    selector: '[Disablecopy]'
})
export class DisablecopyDirective {

    constructor() { }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }
}


@Directive({
    selector: '[DisableCut]'
})
export class DisableCutDirective {

    constructor() { }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }
}

@Directive({
    selector: '[DisableEnter]'
})
export class DisableEnterDirective {

    constructor() { }

    @HostListener('keydown', ['$event']) //keydown, not keyup
    onKeyDown(event: any) {
        if (event.keyCode === 13) { // 13 = enter
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./SignClient/app/shared/directives/DisableKeyPress.directive.ts